module.exports = "/assets/data/01cedd8af574dff35ab070c70efe4a88-SN1.data.json";